import type { EditStepKind, EditStepPhraseKey } from "./types";

const PREFIX = "smartSurveyor.cablesBeta.editStep";

/** Steps whose sentence names the run, when the run has a printed name. */
const NAMES_A_RUN: EditStepKind[] = [
  "reshape",
  "feedPoint",
  "cableType",
  "addRun",
  "removeRun",
];

export const editStepPhraseKey: EditStepPhraseKey = ({ kind, hasRun }) =>
  `${PREFIX}${kind[0].toUpperCase()}${kind.slice(1)}${
    hasRun && NAMES_A_RUN.includes(kind) ? "OnRun" : ""
  }`;
